import { connect } from 'react-redux';
import HomeWrapper from "../components/general/HomeWrapper";
import { GET_DASHBOARD } from '../store/actions/dashboard';

const mapStateToProps = state => {
    return {
        data: state.dashboardR,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GET_DASHBOARD: body => dispatch(GET_DASHBOARD(body))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeWrapper);


// WEBPACK FOOTER //
// ./src/containers/Home.js